// @flow
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { SITE_HOST } from 'utils/Config';
import styles from './SearchBox.styles';

class SearchBox extends React.Component<Props> {
    constructor(props)  {
        super(props);
        this.state = {
          open: false,
        };
    }

    render() {
        const {classes, className} = this.props;
        return (
          <form
            action="https://google.com/search"
            target="_blank"
            className={classNames(className, classes.form, 'gsearch-form')}
          >
            <input name="q" className={classes.input} placeholder="جستجو" />
            <input name="domains" type="hidden" value={SITE_HOST} />
            <input name="sitesearch" type="hidden" value={SITE_HOST} />
            <input name="ie" type="hidden" value="utf-8" />
            <input name="oe" type="hidden" value="utf-8" />
            <input name="hl" type="hidden" value="fa" />
            <button type="submit" className={classes.searchIcon}></button>
          </form>
        );
    }
}

const mapStateToProps = state => ({
  menuList: state.menu,
  navigation: state.navigation
});

const styledComponent = withStyles(styles, {withTheme: true})(SearchBox);
const Component = connect(mapStateToProps)(styledComponent);
export {Component as SearchBox};
export default Component;